import { TargetCouponData } from '@/types/coupon';

export function shouldFetchOnLoginTransition(prevLogin: boolean | undefined, isLogin: boolean): boolean {
  return isLogin && prevLogin !== true;
}

export function pickTargetingCoupon(targetingCoupons: TargetCouponData[] | undefined): TargetCouponData | null {
  return targetingCoupons?.find(item => item.refer_type === 'targeting_coupon') ?? null;
}

export function normalizeProductId(productId: number): number | null {
  const idNum = Number(productId);
  if (!Number.isFinite(idNum)) {
    return null;
  }

  return idNum;
}
